import React, { useEffect } from "react";
import styles from "./DevelopmentFinanceBlogs.module.scss";
import Footer from "../../components/Footer";
import CompareContainer7 from "../../components/CompareContainer/CompareContainer7";
import TypeOfRequirements from "../../components/TypeOfRequirements";
import MatchingMortgages7 from "../../components/MatchingMortgages/MatchingMortgages7";
import NewsContainer from "../../components/NewsContainer";
import LoanApplication7 from "../../components/LoanApplication/LoanApplication7";
import HeroSection from "../../components/HeroSection/HeroSection";
import TestimonialsContainer from "../../components/TestimonialsContainer";
const DevelopmentFinanceBlogs7 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.developmentFinanceBlogs}>
      <HeroSection title="Development Finance" />
      <CompareContainer7 title="Development Finance" />
      <TypeOfRequirements title="Development Finance" />
      <MatchingMortgages7 title="Development Finance" />
      <NewsContainer title="Development Finance" />
      <LoanApplication7 title="Development Finance" />
      <TestimonialsContainer title="Development Finance" />
      <Footer title="Development Finance" />
    </div>
  );
};

export default DevelopmentFinanceBlogs7;
